// removed by extract-text-webpack-plugin
module.exports = {"nonDraggableElement":"base__nonDraggableElement___11kz-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/base.scss
 ** module id = 689
 ** module chunks = 0
 **/